import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { breakTitle } from "../../../Custom/Custom";




export const generateExcel = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:L1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowText
  firstHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).value = excelObjectData.firstRowExportDate;
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).font = { bold: true, name: 'SansSerif', size: 8 }; //cell No- 13
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

  //Second Row Design and  Merge cells A2:M2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 55;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 16;

  });


  //excel Hindi Column
  const headerRow4 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow4.height = 55;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.width = 50;
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    column.width = 16;
  });




  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      const baseFont = { name: 'SansSerif', size: 10 };
      const strValue = typeof value === 'string' ? value.trim() : '';
      const isPercentValue = /^[-+]?\d+(\.\d+)?%$/.test(strValue);
      if (isPercentValue) {
        const numericValue = parseFloat(strValue.replace('%', ''));
        let color = null;
        if (numericValue < 0) color = { argb: 'FFFF0000' }; // red
        else if (numericValue > 0) color = { argb: 'FF00B050' }; // green
        else color = { argb: 'FF1E5EFF' }; // blue
        cell.font = { ...baseFont, color };
      } else {
        cell.font = baseFont;
      }
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' },
      };
      // Customize styling for the cells if needed
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};



export const generateExcelASI = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;


  //Second Row Design and  Merge cells A2:K1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  //Third Row Design and  Merge cells A3:L3
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fourth Row Design and  Merge cells A3:L3
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 55;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;

  });

  excelObjectData.excelRowData.forEach((row) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};





//IIP Annual Agriculture Report

export const generateExcelIIP = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);




  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:10};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 20;
  firstHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };





  // First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Second Row Design and Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row Design and Merge cells A3:L3
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  const headerRow1 = worksheet.addRow([
    'Group/Items', 'Weight', '2011-12\nBase Volume\n(Th.M.T.)',
    `${excelObjectData.baseYear - 2}-${excelObjectData.baseYear - 1}(F)`, '', '',
    `${excelObjectData.baseYear - 1}-${excelObjectData.baseYear}(P)`, '', '',
    `${excelObjectData.baseYear}-${parseInt(excelObjectData.baseYear) + 1}(Q)`, '', ''
  ]);
  headerRow1.height = 20;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('D5:F5');
  worksheet.mergeCells('G5:I5');
  worksheet.mergeCells('J5:L5');

  // Create the second row of headers (individual columns under year ranges)
  const headerRow2 = worksheet.addRow([
    '', '', '',
    'Volume\n(Th.M.T.)', 'Index Col.4/3*100', 'IW',
    'Volume\n(Th.M.T.)', 'Index Col.6/3*100', 'IW',
    'Volume\n(Th.M.T.)', 'Index Col.8/3*100', 'IW'
  ]);
  headerRow2.height = 35;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('A5:A6');
  worksheet.mergeCells('B5:B6');
  worksheet.mergeCells('C5:C6');

  headerRow1.eachCell((cell, colNumber) => {
    worksheet.getColumn(colNumber).width = 15;
  });
  headerRow2.eachCell((cell, colNumber) => {
    worksheet.getColumn(colNumber).width = 15;
  });

  // Excel Data Loop using map
  excelObjectData.excelRowData.map((row) => {
  
    if (Array.isArray(row)) {
      const group = ['(1)FOOD GRAINS', '(2)CATTLE FEED', '(3)CASH CROPS'];
      const subGroup = ['(a) Cereals', '(b) pulses', '(a) fruits and Vegetables', '(b) Sugar Cane', '(c) Oil Seeds', '(d) Others']
      const dataRow = worksheet.addRow(row);
      dataRow.height = null;
      let isTotalRow = false;
      let applyRedColor = false;
      let applyGreenColor = false;



      row.map((value) => {
        if (group.includes(value)) {
          applyGreenColor = true;
        } else if (subGroup.includes(value)) {
          applyRedColor = true;
        }
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        return value; // Return the value to maintain array structure
      });


      row.map((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = { name: 'SansSerif', size: 10 };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }


        if (applyRedColor) {
          cell.font.color = { argb: 'FF0000' }; // Red color
        } else if (applyGreenColor) {
          cell.font.color = { argb: 'FF008000' }; // Green color
        }
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 15, bold: true };
        });
      }
    } else {
      console.error('Invalid row data:', row);
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


//IIP WholeSale Kanpur Report

export const generateExcelIIPWholesaleKanpurReport = async (excelObjectData) => {
  
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);


  //excel Hindi Column

  const headerRow1 = worksheet.addRow(['माह  के प्रथम शुक्रवार के भाव', '', '', `${excelObjectData.firstRowExportDate}`]);
  headerRow1.height = 35;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;


  });

  worksheet.mergeCells('A1:C1');




  const headerRow2 = worksheet.addRow(['जनपद - कानपुर नगर ', '', 'भाव दिनांक :-', `${excelObjectData.priceDate}`]);
  headerRow2.height = 20;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;
  });

  worksheet.mergeCells('A2:B2');



  const headerRow3 = worksheet.addRow([
    'क्रम संख्या',
    'वस्तु का नाम',
    'इकाई मात्रा',
    'औसत  भाव (रू0 में)'
  ]);
  headerRow3.height = 35;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // worksheet.mergeCells('A4:A5');
  // worksheet.mergeCells('B4:B5');
  // worksheet.mergeCells('C4:C5');



  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
   
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


//IIP Top 5 Index

export const generateExcelIIPTopFiveReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;


  //Second Row Design and  Merge cells A2:K1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  const headerRow5 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow5.height = 55;
  headerRow5.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;

  });

  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
    });


    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};



// Group Index Annual Report

export const generateExcelGroupIndexAnnualReport = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  // first Row Design and Merge cells A1:N1

  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  // Second Row Design and Merge cells A2:N2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row Design and Merge cells A3:O3
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row Design and Merge cells A4:O4
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  const headerRow1 = worksheet.addRow([
    'Industry Code', 'Description', 'Weight', 'INDEX(Monthly)', '', '', '', '', '', '', '', '', '', '', '']);



  headerRow1.height = 20;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('D5:O5');



  const headerRow2 = worksheet.addRow([
    '', '', '', 'April', 'May', 'June', 'july', 'August', 'Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'
  ]);

  headerRow2.height = 35;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });




  worksheet.mergeCells('A5:A6');
  worksheet.mergeCells('B5:B6');
  worksheet.mergeCells('C5:C6');


  // });

  worksheet.getColumn('B').width = 30;

  // Excel Data Loop using map
  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' },
      };
      // Customize styling for the cells if needed
    });

  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


// Annual Used Based Categorisation

export const generateAnnualUBCategorisationReport = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  // first Row Design and Merge cells A1:N1

  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  // Second Row Design and Merge cells A2:N2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Third Row Design and Merge cells A3:O3
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  const headerRow1 = worksheet.addRow([
    'Description', 'Weight', 'INDEX(Monthly)', '', '', '', '', '', '', '', '', '', '', '']);



  headerRow1.height = 20;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  worksheet.mergeCells('C4:N4');



  const headerRow2 = worksheet.addRow([
    '', '', 'April', 'May', 'June', 'july', 'August', 'Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'
  ]);

  headerRow2.height = 35;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });




  worksheet.mergeCells('A4:A5');
  worksheet.mergeCells('B4:B5');



  // });

  worksheet.getColumn('A').width = 30;

  // Excel Data Loop using map
  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      // Customize styling for the cells if needed
    });

  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};



// Index Comparison Report

export const generateExcelIndexComparisonReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);


  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:10};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 20;
  firstHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

  //First Row Design and Merge cells A1:D1
  
  // worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  // const firstHeaderRow = worksheet.getRow(1);
  // firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  // firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 14 };
  // firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  // firstHeaderRow.height = 20;
  // firstHeaderRow.getCell(1).border = {
  //   top: { style: 'thin' },
  //   left: { style: 'thin' },
  //   bottom: { style: 'thin' },
  //   right: { style: 'thin' },
  // };


  //Second Row Design and  Merge cells A2:D1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowExportData;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 14 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  //Third Row Design and  Merge cells A3:D3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  //Fourth Row

  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  // excel English Column
  const hasMonthlyIndexComparison = excelObjectData.hasMonthlyIndexComparison === true;
  const prevMonthHex = (excelObjectData.previousMonthHighlightColor || 'ADD8E6').replace(/^#/, '').toUpperCase();
  const prevMonthArgb = prevMonthHex.length === 6 ? 'FF' + prevMonthHex : prevMonthHex;
  const prevMonthFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevMonthArgb } };
  const prevYearHex = (excelObjectData.previousYearHighlightColor || 'FFE4B5').replace(/^#/, '').toUpperCase();
  const prevYearArgb = prevYearHex.length === 6 ? 'FF' + prevYearHex : prevYearHex;
  const prevYearFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevYearArgb } };

  const applyComparisonFill = (cell, colNumber) => {
    if (hasMonthlyIndexComparison) {
      // Monthly: C-D = previous month group (light blue), E-F = previous year group (peach)
      if (colNumber === 3 || colNumber === 4) cell.fill = prevMonthFill;
      if (colNumber === 5 || colNumber === 6) cell.fill = prevYearFill;
      return;
    }
    if (excelObjectData.previousYearHighlightColor && (colNumber === 3 || colNumber === 4)) {
      cell.fill = prevYearFill;
    }
  };

  const applyPercentFontColor = (cell, value, baseFont) => {
    const strValue = typeof value === 'string' ? value.trim() : '';
    const isPercentValue = /^[-+]?\d+(\.\d+)?\s*%$/.test(strValue);
    if (!isPercentValue) {
      cell.font = baseFont;
      return;
    }
    const numericValue = parseFloat(strValue.replace('%', '').trim());
    let color = { argb: 'FF1E5EFF' }; // blue for 0
    if (numericValue < 0) color = { argb: 'FFFF0000' }; // red
    else if (numericValue > 0) color = { argb: 'FF00B050' }; // green
    cell.font = { ...baseFont, color };
  };

  const headerRow4 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow4.height = 55;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    applyComparisonFill(cell, colNumber);
    const column = worksheet.getColumn(colNumber);
    column.width = 20;
  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      const baseFont = { name: 'SansSerif', size: 10 };
      applyPercentFontColor(cell, value, baseFont);
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      applyComparisonFill(cell, index + 1);
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




//Major Group Index Report

export const IIPMajorGroupIndexReport = async ({ excelObjectData, fileName, fileType }) => {

  const workbook = new ExcelJS.Workbook();


  for (let i = 0; i < excelObjectData.length; i++) {
    let worksheet = workbook.addWorksheet(excelObjectData[i].sheetName);
    if (i === 0) {
      if (excelObjectData[i].firstRowMergeCells) {
        worksheet.mergeCells(excelObjectData[i].firstRowMergeCells);
      }
      const firstHeaderRow = worksheet.getRow(1);
      firstHeaderRow.getCell(1).value = excelObjectData[i].firstRowExportData
      firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
      firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      firstHeaderRow.height = 50;
      firstHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };



      //Second Row Design and  Merge cells A2:D1
      worksheet.mergeCells(excelObjectData[i].secondRowMergeCells);
      const secondHeaderRow = worksheet.getRow(2);
      secondHeaderRow.getCell(1).value = excelObjectData[i].secondRowText;
      secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
      secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      secondHeaderRow.height = 20;
      secondHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

      //Third Row Design and  Merge cells A3:D3

      worksheet.mergeCells(excelObjectData[i].thirdRowMergeCells);
      const thirdHeaderRow = worksheet.getRow(3);
      thirdHeaderRow.getCell(1).value = excelObjectData[i].thirdRowText;
      thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
      thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      thirdHeaderRow.height = 20;
      thirdHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };


      //Fourth Row Design and  Merge cells A4:D4

      worksheet.mergeCells(excelObjectData[i].fourthRowMergeCells);
      const fourthHeaderRow = worksheet.getRow(4);
      fourthHeaderRow.getCell(1).value = excelObjectData[i].fourthRowText;
      fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
      fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      fourthHeaderRow.height = 20;
      fourthHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    } 
    if (i === 1 || i === 2){
      // Index 1 and 2 - Custom Header Style
      // if (excelObjectData[i].firstRowMergeCells) {
      //   worksheet.mergeCells(excelObjectData[i].firstRowMergeCells);
      // }
      worksheet.mergeCells('A1:Q1');
      const firstHeaderRow = worksheet.getRow(1);
      firstHeaderRow.getCell(1).value = excelObjectData[i].firstRowExportData
      firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
      firstHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      firstHeaderRow.height = 50;
      firstHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }

    const headerRow1 = worksheet.addRow(excelObjectData[i].headerEnglishColumns);
    headerRow1.height = 70;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;


    });



    excelObjectData[i].excelRowData.forEach((row) => {
      const dataRow = worksheet.addRow(row);
      dataRow.height = null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = { name: 'SansSerif', size: 10 };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });


  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  FileSaver.saveAs(blob, `${fileName}.${fileType}`);
};


// Index Report


export const IIPIndexReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:D1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 20;


  //Second Row Design and  Merge cells A2:D1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 50;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin', color: { argb: 'ff7966' } },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  //Third Row Design and  Merge cells A3:D3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fourth Row Design and  Merge cells A4:D4

  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fifth Row Design and  Merge cells A4:D4

  worksheet.mergeCells(excelObjectData.fifthRowMergeCells);
  const fifthHeaderRow = worksheet.getRow(5);
  fifthHeaderRow.getCell(1).value = excelObjectData.fifthRowText;
  fifthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fifthHeaderRow.height = 20;
  fifthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Optional highlight colors for "previous month" and "previous year" groups.
  // Defaults match UBReport / screenshot reference.
  const prevYearHex = (excelObjectData.previousYearHighlightColor || 'FFE4B5').replace(/^#/, '').toUpperCase();
  const prevYearArgb = prevYearHex.length === 6 ? 'FF' + prevYearHex : prevYearHex;
  const prevYearFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevYearArgb } };
  const prevMonthHex = (excelObjectData.previousMonthHighlightColor || 'ADD8E6').replace(/^#/, '').toUpperCase();
  const prevMonthArgb = prevMonthHex.length === 6 ? 'FF' + prevMonthHex : prevMonthHex;
  const prevMonthFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevMonthArgb } };

  // Computed column ranges for grouped headers (used again for data cell fills).
  let groupRangesForData = [];

  if (excelObjectData.groupedHeader?.fixedHeaders && Array.isArray(excelObjectData.groupedHeader?.groups)) {
    const fixedHeaders = excelObjectData.groupedHeader.fixedHeaders;
    const groups = excelObjectData.groupedHeader.groups;

    const topHeader = [...fixedHeaders];
    groups.forEach((group) => {
      topHeader.push(group.title);
      const extraCount = Math.max((group.columns || []).length - 1, 0);
      for (let i = 0; i < extraCount; i += 1) topHeader.push('');
    });

    const subHeader = new Array(fixedHeaders.length).fill('');
    groups.forEach((group) => {
      (group.columns || []).forEach((col) => subHeader.push(col));
    });

    const headerRow1 = worksheet.addRow(topHeader);
    const headerRow2 = worksheet.addRow(subHeader);
    headerRow1.height = 28;
    headerRow2.height = 46;

    const firstHeaderRowNumber = headerRow1.number;
    const secondHeaderRowNumber = headerRow2.number;
    const fixedCount = fixedHeaders.length;

    for (let c = 1; c <= topHeader.length; c += 1) {
      const col = worksheet.getColumn(c);
      col.width = 15;
      const topCell = headerRow1.getCell(c);
      const subCell = headerRow2.getCell(c);
      topCell.font = { bold: true, name: 'SansSerif', size: 10 };
      topCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      topCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      subCell.font = { bold: true, name: 'SansSerif', size: 10 };
      subCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      subCell.value = breakTitle(subCell.value);
      subCell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }

    for (let c = 1; c <= fixedCount; c += 1) {
      worksheet.mergeCells(firstHeaderRowNumber, c, secondHeaderRowNumber, c);
      const mergedCell = worksheet.getCell(firstHeaderRowNumber, c);
      mergedCell.value = breakTitle(fixedHeaders[c - 1]);
      mergedCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    }

    let startCol = fixedCount + 1;
    groups.forEach((group, groupIndex) => {
      const colCount = (group.columns || []).length;
      if (colCount > 0) {
        const endCol = startCol + colCount - 1;
        worksheet.mergeCells(firstHeaderRowNumber, startCol, firstHeaderRowNumber, endCol);
        const mergedCell = worksheet.getCell(firstHeaderRowNumber, startCol);
        mergedCell.value = group.title;
        mergedCell.font = { bold: true, name: 'SansSerif', size: 10 };
        mergedCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

        // Decide fill for this group (if any)
        // - group[0] => current period (no fill)
        // - group[1] => previous month/previous period (blue)
        // - group[2] => previous year (peach)
        // For 2-group reports (Annual/Nine Months), group[1] is treated as previous year (peach).
        let fill = null;
        if (groups.length >= 3) {
          if (groupIndex === 1) fill = prevMonthFill;
          if (groupIndex === 2) fill = prevYearFill;
        } else if (groups.length === 2) {
          if (groupIndex === 1) fill = prevYearFill;
        }

        if (fill) {
          groupRangesForData.push({ startCol, endCol, fill });
          // Apply to grouped header rows (both top and sub header) for this group.
          for (let c = startCol; c <= endCol; c += 1) {
            worksheet.getCell(firstHeaderRowNumber, c).fill = fill;
            worksheet.getCell(secondHeaderRowNumber, c).fill = fill;
          }
        }

        startCol = endCol + 1;
      }
    });
  } else {
    const headerRow1 = worksheet.addRow(excelObjectData.headerEnglishColumns);
    headerRow1.height = 70;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 15;
    });
  }



  excelObjectData.excelRowData.forEach((row, rowIndex) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = 30;
    let isTotalRow = false;
    let isNic5dEmpty = false;
    // New columns: [S.No, NIC-3d, NIC-4d, NIC-5d, Item, NPCMS Code, NIC-2d, Item Name, ...]
    let itemValue = row[4] || "";
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      const baseFont = { name: 'SansSerif', size: 10 };
      const strVal = typeof value === 'string' ? value.trim() : '';
      const isPercentValue = /^[-+]?\d+(\.\d+)?\s*%$/.test(strVal);
      if (isPercentValue) {
        const numericValue = parseFloat(strVal.replace('%', '').trim());
        let color = null;
        if (numericValue < 0) color = { argb: 'FFFF0000' }; // red
        else if (numericValue > 0) color = { argb: 'FF00B050' }; // green
        else color = { argb: 'FF1E5EFF' }; // blue (0.00%)
        cell.font = { ...baseFont, color };
      } else {
        cell.font = baseFont;
      }
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

      // Apply previous-month/year background fills to data cells (same columns as grouped headers).
      if (groupRangesForData.length > 0) {
        const colNumber = index + 1;
        for (let i = 0; i < groupRangesForData.length; i += 1) {
          const r = groupRangesForData[i];
          if (colNumber >= r.startCol && colNumber <= r.endCol) {
            cell.fill = r.fill;
            break;
          }
        }
      }

      if (value === 'TOTAL') {
        isTotalRow = true;
      }

      // NIC-5d column (0-based index 3). When empty, treat as group row and merge left columns.
      if (index === 3 && value === "") { 
        // Merge S.No..NIC-5d
        worksheet.mergeCells(dataRow.number, 1, dataRow.number, 4);
        dataRow.getCell(1).value = itemValue;
        // Merge Weight..B.P.(Qty) to keep layout compact on group rows
        worksheet.mergeCells(dataRow.number, 9, dataRow.number, 11);
        isNic5dEmpty = true;
      }
    });

    const isLastRow = rowIndex === excelObjectData.excelRowData.length - 1;
    const colors = {
      yellow: { argb: 'FFFF00' },
      green: { argb: '00FF00' }
    };

    let fillColor = {}; 

    // Determine the fill color only if it's the last row and 'NIC5d' is empty
    if (isNic5dEmpty && isLastRow) {
      fillColor = colors.green;
    } else if (isNic5dEmpty) {
      fillColor = colors.yellow;
    }

    if (fillColor.argb) {
      // Item Name column (8) + CP (12) + Index (13)
      dataRow.getCell(8).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: fillColor
      };

      dataRow.getCell(12).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: fillColor
      };

      dataRow.getCell(13).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: fillColor
      };
    }

    const highlightInjected = Array.isArray(excelObjectData.rowHighlightFlags)
      && excelObjectData.rowHighlightFlags[rowIndex] === true
      && !isTotalRow
      && !isNic5dEmpty;
    if (highlightInjected) {
      const injectedHex = String(excelObjectData.injectedHighlightColor || 'FFFF99').replace(/^#/, '').toUpperCase();
      const injectedArgb = injectedHex.length === 6 ? `FF${injectedHex}` : injectedHex;
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: injectedArgb } };
      });
    }

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        const val = typeof cell.value === 'string' ? cell.value.trim() : '';
        const isPercentValue = /^[-+]?\d+(\.\d+)?\s*%$/.test(val);
        if (isPercentValue) {
          const numericValue = parseFloat(val.replace('%', '').trim());
          let color = null;
          if (numericValue < 0) color = { argb: 'FFFF0000' };
          else if (numericValue > 0) color = { argb: 'FF00B050' };
          else color = { argb: 'FF1E5EFF' };
          cell.font = { name: 'SansSerif', size: 12, bold: true, color };
        } else {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        }
      });
    }
  });




  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};

export const generateUBReport = async ({ excelObjectData, fileName, fileType }) => {

  const workbook = new ExcelJS.Workbook();

  for (let i = 0; i < excelObjectData.length; i++) {

  const worksheet = workbook.addWorksheet(excelObjectData[i].sheetName);

  //First Row Design and Merge cells A1:D1
  worksheet.mergeCells(excelObjectData[i].firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData[i].firstRowExportData
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 20;


  if(excelObjectData[i].sheetName ==='IIPUBReport'){

  //Second Row Design and  Merge cells A2:D1
  worksheet.mergeCells(excelObjectData[i].secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData[i].secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 50;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin', color: { argb: 'ff7966' } },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  //Third Row Design and  Merge cells A3:D3

  worksheet.mergeCells(excelObjectData[i].thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData[i].thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fourth Row Design and  Merge cells A4:D4

  worksheet.mergeCells(excelObjectData[i].fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData[i].fourthRowText;
  fourthHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fifth Row Design and  Merge cells A4:D4

  worksheet.mergeCells(excelObjectData[i].fifthRowMergeCells);
  const fifthHeaderRow = worksheet.getRow(5);
  fifthHeaderRow.getCell(1).value = excelObjectData[i].fifthRowText;
  fifthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fifthHeaderRow.height = 20;
  fifthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  const numCols = (excelObjectData[i].headerEnglishColumns || []).length;
  const hasPreviousYear = excelObjectData[i].hasPreviousYear === true && numCols === 9;
  const hasMonthlyComparison = excelObjectData[i].hasMonthlyComparison === true && numCols === 11;
  const prevYearHex = (excelObjectData[i].previousYearHighlightColor || 'FFE4B5').replace(/^#/, '').toUpperCase();
  const prevYearArgb = prevYearHex.length === 6 ? 'FF' + prevYearHex : prevYearHex;
  const prevYearFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevYearArgb } };
  const prevMonthHex = (excelObjectData[i].previousMonthHighlightColor || 'ADD8E6').replace(/^#/, '').toUpperCase();
  const prevMonthArgb = prevMonthHex.length === 6 ? 'FF' + prevMonthHex : prevMonthHex;
  const prevMonthFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: prevMonthArgb } };

  const headerBorder = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  const headerFont = { bold: true, name: 'SansSerif', size: 10 };
  const headerAlign = { horizontal: 'center', vertical: 'middle', wrapText: true };

  if (hasMonthlyComparison && excelObjectData[i].currentMonthLabel != null && excelObjectData[i].previousMonthLabel != null && excelObjectData[i].previousYearLabelMonthly != null) {
    // Row 6: A-E = headers; F-G = current month; H-I = previous month (blue); J-K = previous year (peach)
    const yearRow = worksheet.addRow([
      'NIC-5d', 'NIC-2d', 'Item Name', 'Weight', 'Units',
      excelObjectData[i].currentMonthLabel,
      '',
      excelObjectData[i].previousMonthLabel,
      '',
      excelObjectData[i].previousYearLabelMonthly,
      ''
    ]);
    yearRow.height = 22;
    worksheet.mergeCells(yearRow.number, 6, yearRow.number, 7);   // F6:G6
    worksheet.mergeCells(yearRow.number, 8, yearRow.number, 9);   // H6:I6
    worksheet.mergeCells(yearRow.number, 10, yearRow.number, 11);  // J6:K6
    yearRow.eachCell((cell, colNumber) => {
      cell.font = headerFont;
      cell.alignment = headerAlign;
      cell.border = headerBorder;
      if (colNumber >= 8 && colNumber <= 9) cell.fill = prevMonthFill;
      if (colNumber >= 10 && colNumber <= 11) cell.fill = prevYearFill;
    });

    const headerRow2 = worksheet.addRow(['', '', '', '', '', 'Index(I)', 'Index* Wt', 'Index(I)', 'Index* Wt', 'Index(I)', 'Index* Wt']);
    headerRow2.height = 70;
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = headerFont;
      cell.alignment = headerAlign;
      if (colNumber >= 6) cell.value = breakTitle(cell.value);
      cell.border = headerBorder;
      if (colNumber >= 8 && colNumber <= 9) cell.fill = prevMonthFill;
      if (colNumber >= 10 && colNumber <= 11) cell.fill = prevYearFill;
    });

    for (let c = 1; c <= 5; c++) {
      worksheet.mergeCells(yearRow.number, c, headerRow2.number, c);
    }

    worksheet.getColumn(3).width = 30;
    for (let c = 1; c <= 11; c++) {
      if (c >= 6 && c <= 11) worksheet.getColumn(c).width = 20;
      else if (worksheet.getColumn(c).width < 15) worksheet.getColumn(c).width = 15;
    }
  } else if (hasPreviousYear && excelObjectData[i].currentYearLabel && excelObjectData[i].previousYearLabel) {
    const prevLabel = excelObjectData[i].previousYearLabel;
    const prevYearText = /annual\s+report/i.test(prevLabel) ? prevLabel : `Annual report ${prevLabel}`;
    // Row 6: A-E = headers; F-G merged = "Annual report 2025-2026"; H-I merged = previous year (yellow), single "Annual report"
    const yearRow = worksheet.addRow([
      'NIC-5d', 'NIC-2d', 'Item Name', 'Weight', 'Units',
      `Annual report ${excelObjectData[i].currentYearLabel}`,
      '', // G merged with F
      prevYearText,
      ''  // I merged with H
    ]);
    yearRow.height = 22;
    worksheet.mergeCells(yearRow.number, 6, yearRow.number, 7);   // F6:G6
    worksheet.mergeCells(yearRow.number, 8, yearRow.number, 9);   // H6:I6
    yearRow.eachCell((cell, colNumber) => {
      cell.font = headerFont;
      cell.alignment = headerAlign;
      cell.border = headerBorder;
      if (colNumber >= 8 && colNumber <= 9) cell.fill = prevYearFill;
    });

    // Row 7: only F-I (Index(I), Index* Wt, Index(I), Index* Wt); A-E will be merged with row 6
    const headerRow2 = worksheet.addRow(['', '', '', '', '', 'Index(I)', 'Index* Wt', 'Index(I)', 'Index* Wt']);
    headerRow2.height = 70;
    headerRow2.eachCell((cell, colNumber) => {
      cell.font = headerFont;
      cell.alignment = headerAlign;
      if (colNumber >= 6) cell.value = breakTitle(cell.value);
      cell.border = headerBorder;
      if (colNumber >= 8 && colNumber <= 9) cell.fill = prevYearFill;
    });

    // Merge A-E vertically: row 6 and 7 (so A6:A7, B6:B7, ... E6:E7)
    for (let c = 1; c <= 5; c++) {
      worksheet.mergeCells(yearRow.number, c, headerRow2.number, c);
    }

    worksheet.getColumn(3).width = 30;
    for (let c = 1; c <= 9; c++) {
      if (c >= 6 && c <= 9) {
        worksheet.getColumn(c).width = 20; // F,G,H,I - wider for Index(I) & Index* Wt
      } else if (worksheet.getColumn(c).width < 15) {
        worksheet.getColumn(c).width = 15;
      }
    }
  } else {
    const headerRow1 = worksheet.addRow(excelObjectData[i].headerEnglishColumns);
    headerRow1.height = 70;
    headerRow1.eachCell((cell, colNumber) => {
      cell.font = headerFont;
      cell.alignment = headerAlign;
      cell.value = breakTitle(cell.value);
      cell.border = headerBorder;
      const column = worksheet.getColumn(colNumber);
      column.width = colNumber >= 6 ? 20 : (colNumber === 3 ? 30 : 15); // F,G wider; C=30
    });
  }



  excelObjectData[i].excelRowData.forEach((row, rowIndex) => {
    const dataRow = worksheet.addRow(row);
    dataRow.height = 30;
    let isTotalRow = false;
    let isNic5dEmpty = false;
    const isCategoryRow = (row[0] === '' || row[0] == null) && (row[2] !== '' && row[2] != null) && (row[3] === '' || row[3] == null);
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (hasMonthlyComparison && !isCategoryRow) {
        if (index >= 7 && index <= 8) cell.fill = prevMonthFill;
        else if (index >= 9 && index <= 10) cell.fill = prevYearFill;
      } else if (hasPreviousYear && index >= 7 && index <= 8 && !isCategoryRow) {
        cell.fill = prevYearFill;
      }

      if (value === 'TOTAL') {
        isTotalRow = true;
      }


      if (index === 1) {
        // Get the values from column 1 and column 2
        const valueCol1 = dataRow.getCell(1).value;
        const valueCol2 = dataRow.getCell(2).value;
        const valueCol3 = dataRow.getCell(3).value;
        const valueCol4 = dataRow.getCell(4).value;
    
        // Check if column 1 is empty and column 2 has data
        if (valueCol1 === "" && valueCol2 !== "" ) {
            worksheet.mergeCells(dataRow.number, 1, dataRow.number, 3);
            dataRow.getCell(1).value = valueCol2;
            isNic5dEmpty = true;
        }
        if (valueCol1 === "" && valueCol3 !== "" && !valueCol4) {
          const mergeEndCol = hasMonthlyComparison ? 11 : (hasPreviousYear ? 9 : 7);
          // Category row (e.g. Basic Goods): merge A to I (col 1 to mergeEndCol), no yellow
          worksheet.mergeCells(dataRow.number, 1, dataRow.number, mergeEndCol);
          dataRow.getCell(1).value = valueCol3;
          const mergedCell = dataRow.getCell(1);
          mergedCell.alignment = { horizontal: 'left', vertical: 'middle' };
          mergedCell.font = { bold: true };
          isNic5dEmpty = true;
      }
    }
    });

    const isLastRow = rowIndex === excelObjectData[i].excelRowData.length - 1;
   

    if (isTotalRow) {
      dataRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = { name: 'SansSerif', size: 12, bold: true };
      });
    }
  });



} else if(excelObjectData[i].sheetName ==='IIPUBReportChart'){  //Chart Sheet

  worksheet.mergeCells(excelObjectData[i].thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(2);
  thirdHeaderRow.getCell(1).value = excelObjectData[i].thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


        const imageId = workbook.addImage({
          // buffer: imageBuffer,
          base64: excelObjectData[i].base64String,
          extension: 'png', 
          
      });

      // Add image to worksheet
      worksheet.addImage(imageId, {
          tl: { col: 0, row: 3 },
          ext: { width: 1500, height: 750 }  
      });


}


}


  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const saveFileName = `${fileName}.${fileType}`;
  FileSaver.saveAs(blob, saveFileName);
};




// FRQRReport ********************************
export const generateExcelFrQrReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:D1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 20;


  //Second Row Design and  Merge cells A2:D1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 20, color: { argb: 'ff7966' } };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 40;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin', color: { argb: 'ff7966' } },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  //Third Row Design and  Merge cells A3:D3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fourth Row Design and  Merge cells A4:D4

  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fifth Row Design and  Merge cells A4:D4

  worksheet.mergeCells(excelObjectData.fifthRowMergeCells);
  const fifthHeaderRow = worksheet.getRow(5);
  fifthHeaderRow.getCell(1).value = excelObjectData.fifthRowText;
  fifthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12 };
  fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fifthHeaderRow.height = 20;
  fifthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  const headerRow1 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow1.height = 50;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    column.width = 15;

      if (colNumber === 4) {
        column.width = 30;
      }
 });



  excelObjectData.excelRowData.forEach((row, rowIndex) => {
    const dataRow = worksheet.addRow(row);
     dataRow.height = 30;
    let isTotalRow = false;
    let isLastTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
     if(value==='Total'){
      isLastTotalRow=true;
      worksheet.mergeCells(`A${dataRow.number}:D${dataRow.number}`);
      worksheet.mergeCells(`F${dataRow.number}:H${dataRow.number}`);
     }else{
      if( typeof value === 'string' && value.includes('Total')){
        isTotalRow = true;
        worksheet.mergeCells(`A${dataRow.number}:D${dataRow.number}`);
        worksheet.mergeCells(`F${dataRow.number}:H${dataRow.number}`);
     }
     }
      

     if(isLastTotalRow){
      dataRow.getCell(5).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor:{ argb: '198754' }
      };
      dataRow.getCell(9).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor:{ argb: '198754' }
      };
      dataRow.getCell(10).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor:{ argb: '198754' }// fillColor
      };
      cell.font = {bold:true};
     }

      if(isTotalRow){
        dataRow.getCell(5).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor:{ argb: 'FFFF00' }
        };
        dataRow.getCell(9).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor:{ argb: 'FFFF00' }
        };
        dataRow.getCell(10).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor:{ argb: 'FFFF00' }// fillColor
        };
        cell.font = {bold:true};
        }
   });

 });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};